import { createFileRoute } from '@tanstack/react-router';
import { DownloadApp } from '@/features/system/DownloadApp';

export const Route = createFileRoute('/_public/download-app')({ component: DownloadApp });
